"use strict";

var _toConsumableArray = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _regeneratorRuntime = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/regenerator/index.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapTypeToComponent = exports.bundleDocument = exports.bundle = exports.OasVersion = void 0;

var isEqual = require("lodash.isequal");

var resolve_1 = require("./resolve");

var visitors_1 = require("./visitors");

var oas3_1 = require("./types/oas3");

var oas2_1 = require("./types/oas2");

var oas3_1_1 = require("./types/oas3_1");

var types_1 = require("./types");

var walk_1 = require("./walk");

var oas_types_1 = require("./oas-types");

var ref_utils_1 = require("./ref-utils");

var rules_1 = require("./config/rules");

var no_unresolved_refs_1 = require("./rules/no-unresolved-refs");

var utils_1 = require("./utils");

var redocly_1 = require("./redocly");

var remove_unused_components_1 = require("./rules/oas2/remove-unused-components");

var remove_unused_components_2 = require("./rules/oas3/remove-unused-components");

var OasVersion;

(function (OasVersion) {
  OasVersion["Version2"] = "oas2";
  OasVersion["Version3_0"] = "oas3_0";
  OasVersion["Version3_1"] = "oas3_1";
})(OasVersion = exports.OasVersion || (exports.OasVersion = {}));

function bundle(opts) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var ref, doc, _opts$externalRefReso, externalRefResolver, _opts$base, base, document;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ref = opts.ref, doc = opts.doc, _opts$externalRefReso = opts.externalRefResolver, externalRefResolver = _opts$externalRefReso === void 0 ? new resolve_1.BaseResolver(opts.config.resolve) : _opts$externalRefReso, _opts$base = opts.base, base = _opts$base === void 0 ? null : _opts$base;

            if (ref || doc) {
              _context.next = 3;
              break;
            }

            throw new Error('Document or reference is required.\n');

          case 3:
            if (!(doc !== undefined)) {
              _context.next = 7;
              break;
            }

            _context.t0 = doc;
            _context.next = 10;
            break;

          case 7:
            _context.next = 9;
            return externalRefResolver.resolveDocument(base, ref, true);

          case 9:
            _context.t0 = _context.sent;

          case 10:
            document = _context.t0;

            if (!(document instanceof Error)) {
              _context.next = 13;
              break;
            }

            throw document;

          case 13:
            return _context.abrupt("return", bundleDocument(Object.assign(Object.assign({
              document: document
            }, opts), {
              config: opts.config.styleguide,
              externalRefResolver: externalRefResolver
            })));

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.bundle = bundle;

function bundleDocument(opts) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var document, config, customTypes, externalRefResolver, _opts$dereference, dereference, _opts$skipRedoclyRegi, skipRedoclyRegistryRefs, _opts$removeUnusedCom, removeUnusedComponents, _opts$keepUrlRefs, keepUrlRefs, oasVersion, oasMajorVersion, rules, types, preprocessors, decorators, ctx, resolvedRefMap, bundleVisitor;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            document = opts.document, config = opts.config, customTypes = opts.customTypes, externalRefResolver = opts.externalRefResolver, _opts$dereference = opts.dereference, dereference = _opts$dereference === void 0 ? false : _opts$dereference, _opts$skipRedoclyRegi = opts.skipRedoclyRegistryRefs, skipRedoclyRegistryRefs = _opts$skipRedoclyRegi === void 0 ? false : _opts$skipRedoclyRegi, _opts$removeUnusedCom = opts.removeUnusedComponents, removeUnusedComponents = _opts$removeUnusedCom === void 0 ? false : _opts$removeUnusedCom, _opts$keepUrlRefs = opts.keepUrlRefs, keepUrlRefs = _opts$keepUrlRefs === void 0 ? false : _opts$keepUrlRefs;
            oasVersion = oas_types_1.detectOpenAPI(document.parsed);
            oasMajorVersion = oas_types_1.openAPIMajor(oasVersion);
            rules = config.getRulesForOasVersion(oasMajorVersion);
            types = types_1.normalizeTypes(config.extendTypes((customTypes !== null && customTypes !== void 0 ? customTypes : oasMajorVersion === oas_types_1.OasMajorVersion.Version3) ? oasVersion === OasVersion.Version3_1 ? oas3_1_1.Oas3_1Types : oas3_1.Oas3Types : oas2_1.Oas2Types, oasVersion), config);
            preprocessors = rules_1.initRules(rules, config, 'preprocessors', oasVersion);
            decorators = rules_1.initRules(rules, config, 'decorators', oasVersion);
            ctx = {
              problems: [],
              oasVersion: oasVersion,
              refTypes: new Map(),
              visitorsData: {}
            };

            if (removeUnusedComponents) {
              decorators.push({
                severity: 'error',
                ruleId: 'remove-unused-components',
                visitor: oasMajorVersion === oas_types_1.OasMajorVersion.Version2 ? remove_unused_components_1.RemoveUnusedComponents({}) : remove_unused_components_2.RemoveUnusedComponents({})
              });
            }

            _context2.next = 11;
            return resolve_1.resolveDocument({
              rootDocument: document,
              rootType: types.Root,
              externalRefResolver: externalRefResolver
            });

          case 11:
            resolvedRefMap = _context2.sent;
            bundleVisitor = visitors_1.normalizeVisitors([].concat(_toConsumableArray(preprocessors), [{
              severity: 'error',
              ruleId: 'bundler',
              visitor: makeBundleVisitor(oasMajorVersion, dereference, skipRedoclyRegistryRefs, document, resolvedRefMap, keepUrlRefs)
            }], _toConsumableArray(decorators)), types);
            walk_1.walkDocument({
              document: document,
              rootType: types.Root,
              normalizedVisitors: bundleVisitor,
              resolvedRefMap: resolvedRefMap,
              ctx: ctx
            });
            return _context2.abrupt("return", {
              bundle: document,
              problems: ctx.problems.map(function (problem) {
                return config.addProblemToIgnore(problem);
              }),
              fileDependencies: externalRefResolver.getFiles(),
              rootType: types.Root,
              refTypes: ctx.refTypes,
              visitorsData: ctx.visitorsData
            });

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

exports.bundleDocument = bundleDocument;

function mapTypeToComponent(typeName, version) {
  switch (version) {
    case oas_types_1.OasMajorVersion.Version3:
      switch (typeName) {
        case 'Schema':
          return 'schemas';

        case 'Parameter':
          return 'parameters';

        case 'Response':
          return 'responses';

        case 'Example':
          return 'examples';

        case 'RequestBody':
          return 'requestBodies';

        case 'Header':
          return 'headers';

        case 'SecuritySchema':
          return 'securitySchemes';

        case 'Link':
          return 'links';

        case 'Callback':
          return 'callbacks';

        default:
          return null;
      }

    case oas_types_1.OasMajorVersion.Version2:
      switch (typeName) {
        case 'Schema':
          return 'definitions';

        case 'Parameter':
          return 'parameters';

        case 'Response':
          return 'responses';

        default:
          return null;
      }

  }
}

exports.mapTypeToComponent = mapTypeToComponent; // function oas3Move

function makeBundleVisitor(version, dereference, skipRedoclyRegistryRefs, rootDocument, resolvedRefMap, keepUrlRefs) {
  var components;
  var visitor = {
    ref: {
      leave: function leave(node, ctx, resolved) {
        if (!resolved.location || resolved.node === undefined) {
          no_unresolved_refs_1.reportUnresolvedRef(resolved, ctx.report, ctx.location);
          return;
        }

        if (resolved.location.source === rootDocument.source && resolved.location.source === ctx.location.source && ctx.type.name !== 'scalar' && !dereference) {
          return;
        } // do not bundle registry URL before push, otherwise we can't record dependencies


        if (skipRedoclyRegistryRefs && redocly_1.isRedoclyRegistryURL(node.$ref)) {
          return;
        }

        if (keepUrlRefs && ref_utils_1.isAbsoluteUrl(node.$ref)) {
          return;
        }

        var componentType = mapTypeToComponent(ctx.type.name, version);

        if (!componentType) {
          replaceRef(node, resolved, ctx);
        } else {
          if (dereference) {
            saveComponent(componentType, resolved, ctx);
            replaceRef(node, resolved, ctx);
          } else {
            node.$ref = saveComponent(componentType, resolved, ctx);
            resolveBundledComponent(node, resolved, ctx);
          }
        }
      }
    },
    Root: {
      enter: function enter(root) {
        if (version === oas_types_1.OasMajorVersion.Version3) {
          components = root.components = root.components || {};
        } else if (version === oas_types_1.OasMajorVersion.Version2) {
          components = root;
        }
      }
    }
  };

  if (version === oas_types_1.OasMajorVersion.Version3) {
    visitor.DiscriminatorMapping = {
      leave: function leave(mapping, ctx) {
        for (var _i = 0, _Object$keys = Object.keys(mapping); _i < _Object$keys.length; _i++) {
          var name = _Object$keys[_i];
          var $ref = mapping[name];
          var resolved = ctx.resolve({
            $ref: $ref
          });

          if (!resolved.location || resolved.node === undefined) {
            no_unresolved_refs_1.reportUnresolvedRef(resolved, ctx.report, ctx.location.child(name));
            return;
          }

          var componentType = mapTypeToComponent('Schema', version);

          if (dereference) {
            saveComponent(componentType, resolved, ctx);
          } else {
            mapping[name] = saveComponent(componentType, resolved, ctx);
          }
        }
      }
    };
  }

  function resolveBundledComponent(node, resolved, ctx) {
    var newRefId = resolve_1.makeRefId(ctx.location.source.absoluteRef, node.$ref);
    resolvedRefMap.set(newRefId, {
      document: rootDocument,
      isRemote: false,
      node: resolved.node,
      nodePointer: node.$ref,
      resolved: true
    });
  }

  function replaceRef(ref, resolved, ctx) {
    if (!utils_1.isPlainObject(resolved.node)) {
      ctx.parent[ctx.key] = resolved.node;
    } else {
      // TODO: why $ref isn't optional in OasRef?
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      delete ref.$ref;
      var obj = Object.assign({}, resolved.node, ref);
      Object.assign(ref, obj); // assign ref itself again so ref fields take precedence
    }
  }

  function saveComponent(componentType, target, ctx) {
    components[componentType] = components[componentType] || {};
    var name = getComponentName(target, componentType, ctx);
    components[componentType][name] = target.node;

    if (version === oas_types_1.OasMajorVersion.Version3) {
      return "#/components/".concat(componentType, "/").concat(name);
    } else {
      return "#/".concat(componentType, "/").concat(name);
    }
  }

  function isEqualOrEqualRef(node, target, ctx) {
    var _a;

    if (ref_utils_1.isRef(node) && ((_a = ctx.resolve(node).location) === null || _a === void 0 ? void 0 : _a.absolutePointer) === target.location.absolutePointer) {
      return true;
    }

    return isEqual(node, target.node);
  }

  function getComponentName(target, componentType, ctx) {
    var _ref = [target.location.source.absoluteRef, target.location.pointer],
        fileRef = _ref[0],
        pointer = _ref[1];
    var componentsGroup = components[componentType];
    var name = '';
    var refParts = pointer.slice(2).split('/').filter(utils_1.isTruthy); // slice(2) removes "#/"

    while (refParts.length > 0) {
      name = refParts.pop() + (name ? "-".concat(name) : '');

      if (!componentsGroup || !componentsGroup[name] || isEqualOrEqualRef(componentsGroup[name], target, ctx)) {
        return name;
      }
    }

    name = ref_utils_1.refBaseName(fileRef) + (name ? "_".concat(name) : '');

    if (!componentsGroup[name] || isEqualOrEqualRef(componentsGroup[name], target, ctx)) {
      return name;
    }

    var prevName = name;
    var serialId = 2;

    while (componentsGroup[name] && !isEqualOrEqualRef(componentsGroup[name], target, ctx)) {
      name = "".concat(prevName, "-").concat(serialId);
      serialId++;
    }

    if (!componentsGroup[name]) {
      ctx.report({
        message: "Two schemas are referenced with the same name but different content. Renamed ".concat(prevName, " to ").concat(name, "."),
        location: ctx.location,
        forceSeverity: 'warn'
      });
    }

    return name;
  }

  return visitor;
}